export default "__VITE_ASSET__Uqnux6XN__"